import cn from 'classnames';
import { Image } from '../../../../components/Image/Image';
import { Title } from '../../../../components/Title/Title';
import styles from './Result.module.scss';
export const Result = ({content,data})=>{
  const emotionPoint = data?.points?.E || 0;
  const psysicalPoint = data?.points?.P || 0;
  const {background,title,visibleResult,visibleResultValues,hiddenResult,hiddenResultValues} = content;

  let emotionKey = "0";
  if (emotionPoint >= 4 && emotionPoint <= 7) {
    emotionKey = "1";
  } else if (emotionPoint >= 8 && emotionPoint <= 11) {
    emotionKey = "2";
  } else if (emotionPoint >= 12) {
    emotionKey = "3";
  }
  
  let psysicalKey = String(psysicalPoint); 
  const emotionResult = visibleResultValues[emotionKey].value;
  const emotionResultDescription = visibleResultValues[emotionKey].description;
  const emotionResultColor  = visibleResultValues[emotionKey].color;
  
  const psysicalResult = hiddenResultValues[psysicalKey]?.value;
  const psysicalResultDescription = hiddenResultValues[psysicalKey]?.description;
  const psysicalResultColor = hiddenResultValues[psysicalKey]?.color;
  return (
    <>
    <div className={styles.wrapper}>
      {background && <Image className={styles.background} src={background}/>}
      {title && 
      <Title className={cn(
        styles.title,
        emotionResultColor === 'green' && styles.green,
        emotionResultColor === 'yellow' && styles.yellow,
        emotionResultColor === 'red' && styles.red,
        )} dangerouslySetInnerHTML={{ __html:`<span>${emotionResult}</span> ${title}`  }}/>}
      <div className={styles.block}>
        {visibleResult && 
          <div className={cn(
            styles.result
            )}>
            {visibleResult} <span className={cn(
              emotionResultColor === 'green' && styles.green,
              emotionResultColor === 'yellow' && styles.yellow,
              emotionResultColor === 'red' && styles.red,
            )}>{emotionResult}</span>
          </div> 
        }
        {emotionResultDescription &&
          <div className={styles.description}>
            {emotionResultDescription}
          </div>
        }
        <div className={styles.hidden}>
          {hiddenResult && 
            <div className={styles.result}>
              {hiddenResult} <span className={cn(
              psysicalResultColor === 'green' && styles.green,
              psysicalResultColor === 'yellow' && styles.yellow,
              psysicalResultColor === 'red' && styles.red,
            )}>{psysicalResult}</span>
            </div> 
          }
          {emotionResultDescription &&
            <div className={styles.description}>
              {psysicalResultDescription}
            </div>
          }
        </div>
      </div>
    </div>
    </>
  )
}
